import React, { useCallback } from 'react';
import { DesignInCanvaModalView } from './DesignInCanvaModal.view';
import { ExternalMedia, SourceType } from '../../../../hooks/useMediaUpload';
import { MediaType } from 'models/graphql';
import { useCanva } from '../../../../hooks/useCanva';

type DesignInCanvaModalControllerProps = {
  onCloseHandler: VoidFunction;
  publishLabel: string;
  fileUploadHandlerPage?: (files: ExternalMedia[]) => void;
  fileUploadHandlerPostEditor?: (url: string, canvaId: string) => void;
};

export const DesignInCanvaModalController = ({
  onCloseHandler,
  publishLabel,
  fileUploadHandlerPage,
  fileUploadHandlerPostEditor
}: DesignInCanvaModalControllerProps) => {
  const { canva } = useCanva();

  const openCanvaTemplate = useCallback(
    (width: number, height: number) => {
      canva.createDesign({
        design: {
          id: '',
          dimensions: { width, height }
        },
        editor: {
          fileType: 'jpg',
          publishLabel
        },
        onDesignPublish: ({ exportUrl, designId }) => {
          fileUploadHandlerPage?.([
            { sourceType: SourceType.external, canvaId: designId, url: exportUrl, type: MediaType.PHOTO }
          ]);
          fileUploadHandlerPostEditor?.(exportUrl, designId);
          onCloseHandler();
        }
      });
    },
    [canva, publishLabel, fileUploadHandlerPage, fileUploadHandlerPostEditor, onCloseHandler]
  );

  return <DesignInCanvaModalView onCloseHandler={onCloseHandler} openCanvaTemplate={openCanvaTemplate} />;
};
